var render = function () {var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;
return _c('v-main',{staticClass:"ma-0 pa-0 fill-height",attrs:{"id":"kakaoTalk"}},[_c('v-row',{staticClass:"fill-height",staticStyle:{"height":"90vh"},attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center completeContent"},[_c('span',[_c('v-icon',{attrs:{"x-large":"","color":"#d6af66"}},[_vm._v("mdi-check-circle-outline")])],1),_c('div',[_vm._v("개인정보 활용 동의를"),_c('br'),_vm._v("완료했어요.")])])],1)],1);}
var staticRenderFns = []

export { render, staticRenderFns }